<footer class="site-footer">
    <div class="container-fluid px-lg-5 py-5">
        <div class="row g-5">
            <!-- Column 1: About & Info -->
            <div class="col-lg-3 col-md-6">
                <div class="footer-brand-wrap">
                    <img src="assets/img/logo/4.png" alt="Vaish Girls College Logo" class="footer-logo"
                        onerror="this.style.display='none'">
                    <div class="brand-text">
                        <h4 class="brand-name">Vaish Girls College</h4>
                        <span class="brand-location"><i class="fa fa-map-marker me-1"></i> SAMALKHA, HARYANA</span>
                    </div>
                </div>
                <p class="footer-about-text mt-4">
                    Vaish Girls College Samalkha Panipat is affiliated to Kurukshetra University Kurukshetra(KUK). At
                    Vaish College we believe that each teacher is special and has the potential to excel in many
                    different ways.
                </p>
                <div class="footer-socials mt-4">
                    <a href="https://www.facebook.com/people/Vaish-Girls-College-Samalkha/100057027476705/"
                        target="_blank" class="social-circle"><i class="fab fa-facebook-f"></i></a>
                    <a href="#" class="social-circle"><i class="fab fa-instagram"></i></a>
                    <a href="#" class="social-circle"><i class="fab fa-youtube"></i></a>
                    <a href="#" class="social-circle"><i class="fab fa-twitter"></i></a>
                    <a href="#" class="social-circle"><i class="fab fa-linkedin-in"></i></a>
                </div>
            </div>

            <!-- Column 2: Important Links -->
            <div class="col-lg-3 col-md-6">
                <div class="footer-link-group">
                    <h4 class="footer-heading">Important Links</h4>
                    <span class="heading-line"></span>
                    <ul class="footer-links mt-4">
                        <li><a href="https://amis.highereduhry.ac.in/Login.aspx" target="_blank">MIS Login</a></li>
                        <li><a href="https://harchhatravratti.highereduhry.ac.in/" target="_blank">DHE</a></li>
                        <li><a href="https://scholarships.gov.in/" target="_blank">National Scholarship</a></li>
                        <li><a href="https://erp.highereduhry.ac.in/UserLogin.aspx" target="_blank">ERP Portal</a></li>
                        <li><a href="https://www.highereduhry.ac.in/" target="_blank">Higher Edu, HR</a></li>
                        <li><a href="https://aishe.gov.in/aishe/home" target="_blank">AISHE</a></li>
                    </ul>
                </div>
            </div>

            <!-- Column 3: Quick Links -->
            <div class="col-lg-3 col-md-6">
                <div class="footer-link-group">
                    <h4 class="footer-heading">Quick Links</h4>
                    <span class="heading-line"></span>
                    <ul class="footer-links mt-4">
                        <li><a href="https://admissions.highereduhry.ac.in/" target="_blank">Online Admission</a></li>
                        <li><a href="https://www.kuk.ac.in/" target="_blank">Kurukshetra University</a></li>
                        <li><a href="https://examforms.kuk.ac.in/KukHome/AdminLogIn.aspx" target="_blank">Examination
                                Form</a></li>
                        <li><a href="#">Result</a></li>
                        <li><a href="#">University</a></li>
                        <li><a href="#">Faculty</a></li>
                        <li><a href="assets/images/iqac-letter.jpeg" target="_blank">IQAC</a></li>
                    </ul>
                </div>
            </div>

            <!-- Column 4: Contact Info -->
            <div class="col-lg-3 col-md-6">
                <div class="footer-link-group">
                    <h4 class="footer-heading">Contact Info</h4>
                    <span class="heading-line"></span>
                    <ul class="footer-contact mt-4">
                        <li>
                            <i class="fa fa-phone contact-icon"></i>
                            <div class="contact-text">
                                <span class="contact-label">Call Us</span>
                                <p>0180 251 0882<br>+91-97297-66403<br>+91-89303-19739</p>
                            </div>
                        </li>
                        <li>
                            <i class="fa fa-envelope contact-icon"></i>
                            <div class="contact-text">
                                <span class="contact-label">Email Us</span>
                                <p><a href="mailto:vgcsmk@gmail.com">vgcsmk@gmail.com</a></p>
                            </div>
                        </li>
                        <li>
                            <i class="fa fa-map-marker contact-icon"></i>
                            <div class="contact-text">
                                <span class="contact-label">Location</span>
                                <p>New Grain Market Samalkha,<br>Distt. Samalkha, Haryana-132101</p>
                            </div>
                        </li>
                        <li>
                            <i class="fa fa-clock contact-icon"></i>
                            <div class="contact-text">
                                <span class="contact-label">Working Hours</span>
                                <p>Monday-Friday, 9am-6pm;<br>Sunday Closed</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom py-3">
        <div
            class="container-fluid px-lg-5 text-center text-md-between d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div class="crafted-by-wrap">
                <p class="crafted-text mb-0">
                    Crafted with <i class="fa fa-heart"></i> by <a href="https://okiedokiepay.com/" target="_blank"
                        class="crafted-link">Okie Dokie</a>
                </p>
                <p class="crafted-subtitle mb-0">Haryana's No. 1 Campus Automation Partner</p>
            </div>
            <p class="credits-text mb-0">Affiliated to KUK University | Approved by Govt. of Haryana</p>
        </div>
    </div>
</footer>